import {
  MARKER_CIRCLE_DEFAULT_SIZE,
  MARKER_CIRCLE_STROKE_WIDTH,
} from "./marker-circle.constant";

export const scaleMarkerCircleSize = (scale: number = 1) => {
  const strokeWidth = MARKER_CIRCLE_STROKE_WIDTH;
  const size = MARKER_CIRCLE_DEFAULT_SIZE * scale;

  return {
    width: size,
    height: size,
    mainRadius: size / 2,
    smallRadius: (size - strokeWidth) / 2,
  };
};
